import React from "react";
import classes from "./Footer.module.scss";
import img1 from "../../../assets/img/footer/logo.svg"
import { NavLink } from "react-router-dom";

const Footer = () => {


  return (
    <div className={[classes.footer, ""].join(" ")}>
      <div className={[classes.footerBody, ""].join(" ")}>
        <div className={[classes.footerTop, ""].join(" ")}>
          <div className={[classes.footerTopLogo, ""].join(" ")}>
            <img src={img1} alt="" />
          </div>
          <div className={[classes.footerTopRight, ""].join(" ")}>
            <div className={[classes.footerTopRightMenu, ""].join(" ")}>
              <h3 className={[classes.footerTopRightMenuTitle, ""].join(" ")}>
                Menu
              </h3>
              <div className={[classes.footerTopRightMenuList, ""].join(" ")}>
                <NavLink to={"/"} className={[classes.footerTopRightMenuListItem, ""].join(" ")}>
                  Home
                </NavLink>
                <NavLink to={"/"} className={[classes.footerTopRightMenuListItem, ""].join(" ")}>
                  About
                </NavLink>
                <NavLink to={"/"} className={[classes.footerTopRightMenuListItem, ""].join(" ")}>
                  Services
                </NavLink>
                <NavLink to={"/"} className={[classes.footerTopRightMenuListItem, ""].join(" ")}>
                  Contact
                </NavLink>
              </div>

            </div>
            <div className={[classes.footerTopRightContact, ""].join(" ")}>
              <h3 className={[classes.footerTopRightContactTitle, ""].join(" ")}>
                Contact
              </h3>
              <div className={[classes.footerTopRightContactList, ""].join(" ")}>
                <div className={[classes.footerTopRightContactListItem, ""].join(" ")}>
                  Pawfections@contact.com
                </div>
                <div className={[classes.footerTopRightContactListItem, ""].join(" ")}>
                  +012-345-6789
                </div>
                <div className={[classes.footerTopRightContactListItem, ""].join(" ")}>
                  9889 Lorem Ipsum street, Pellentesque, CA, USA
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={[classes.footerBottom, ""].join(" ")}>
          <div className={[classes.footerBottomLeft, ""].join(" ")}>
            Copyright Dotcreativemarket
          </div>
          <div className={[classes.footerBottomRight, ""].join(" ")}>
            <div className={[classes.footerBottomRightItem, ""].join(" ")}>
              Terms of Use
            </div>
            <div className={[classes.footerBottomRightItem, ""].join(" ")}>
              Privacy Policy
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
